import { AUTH_TOKEN_KEY, REFRESH_TOKEN_KEY } from "./session-keys";
const namespace = "ct";

class LocalStorage {
  baseKey: string;
  sessionOnly: boolean;

  constructor(baseKey = "shared", sessionOnly = false) {
    this.baseKey = baseKey;
    this.sessionOnly = sessionOnly;
  }

  // All the paths for this api domain.
  buildKey = (key: string) => `${namespace}/${this.baseKey}/${key}`;

  getItem = (key: string) => {
    if (!process?.browser) {
      // Running server side.
      return "";
    }
    return (
      (this.sessionOnly
        ? sessionStorage.getItem(this.buildKey(key))
        : localStorage.getItem(this.buildKey(key))) || ""
    );
  };

  setItem = (key: string, value: string) => {
    if (!process?.browser) {
      // Running server side.
      return;
    }

    this.sessionOnly
      ? sessionStorage.setItem(this.buildKey(key), value)
      : localStorage.setItem(this.buildKey(key), value);
  };

  removeItem = (key: string) => {
    if (!process?.browser) {
      // Running server side.
      return;
    }

    this.sessionOnly
      ? sessionStorage.removeItem(this.buildKey(key))
      : localStorage.removeItem(this.buildKey(key));
  };
}

export default LocalStorage;

const clearableLogoutItems = [
  "ct-user",
  "ct-push",
  "ct-bdg",
  "ct-groups",
  "token",
  "tokents",
  AUTH_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  "cache-timeouts",
  "cache-events",
  "cache-stories",
  "cache-collections",
  "cache-organization",
  "cache-community",
  "cache-communities",
];

/**
 * Removes specific items from local storage when a user logs out.
 * Keys to remove are based on what the Dreambig repo currently
 * removes from its localStorage when a user logs out.
 */
export const removeLogoutLocalStorageItems = () =>
  clearableLogoutItems.forEach((key: string) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });
